module.exports = __webpack_public_path__ + "img/recommed-img9.9b356c8a.jpg";